<h5 class="title tipo-second-color bold">{{ 'PRIVATE.DASHBOARD.NEWS.TITLE' | translate }}</h5>
<div class="news_container">    
    <p class="content_news tipo-main-color regular"><span class="title_news tipo-main-color bold"></span> {{ "PRIVATE.DASHBOARD.NEWS.GENERAL-CONTENT" | translate}}</p>
</div>